"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFDataFrame = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const RelativeRSSI_1 = require("./position/RelativeRSSI");
let RFDataFrame = class RFDataFrame extends core_1.DataFrame {
    addRelativeRSSI(object, rssi) {
        if (!this.source) {
            return false;
        }
        this.source.addRelativePosition(new RelativeRSSI_1.RelativeRSSI(object, rssi));
        this.addObject(object);
        return true;
    }
};
exports.RFDataFrame = RFDataFrame;
exports.RFDataFrame = RFDataFrame = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], RFDataFrame);
//# sourceMappingURL=RFDataFrame.js.map